/**
 * ISO timestamp 문자열을 한국 시간(KST) "YYYY-MM-DD HH:mm" 형식으로 포맷.
 * 백엔드가 UTC TIMESTAMPTZ 로 내려준 값을 사용자 친화적으로 표시할 때 사용.
 * 빈 값/잘못된 입력은 '' 반환.
 *
 * 예: "2026-05-14T02:42:51.635842+00:00" → "2026-05-14 11:42"
 */
export function formatKstDateTime(isoString) {
  if (!isoString) return '';
  const d = new Date(isoString);
  if (Number.isNaN(d.getTime())) return '';
  // Asia/Seoul 타임존으로 강제 변환
  const parts = new Intl.DateTimeFormat('ko-KR', {
    timeZone: 'Asia/Seoul',
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', hour12: false,
  }).formatToParts(d);
  const get = (type) => parts.find((p) => p.type === type)?.value || '';
  return `${get('year')}-${get('month')}-${get('day')} ${get('hour')}:${get('minute')}`;
}


export function isWeekend(dateTimeStr) {
  if (!dateTimeStr) return false;
  const [datePart] = dateTimeStr.split('T');
  const [y, m, d] = datePart.split('-').map(Number);
  const dayOfWeek = new Date(y, m - 1, d).getDay();
  return dayOfWeek === 0 || dayOfWeek === 6;
}

/**
 * 차량 이용 일시 기본값 — 현재 시간 + 버퍼시간을 다음 10분 단위로 올림한 ISO 문자열 반환
 *
 * 예: 11:47, buffer=120 → 13:50
 *     22:30, buffer=120 → 다음날 00:30
 *
 * @param {number} bufferMinutes - 버퍼 시간 (분), 기본 120 (#47/#81: 당일 예약은 현재 시각 + 2시간)
 * @returns {string} "yyyy-MM-ddTHH:mm" 형식
 */
export function getDefaultBookingDateTime(bufferMinutes = 120) {
  const now = new Date();
  const target = new Date(now.getTime() + bufferMinutes * 60 * 1000);

  // 분을 다음 10분 단위로 올림 (DateTimePicker의 MINUTES = [0,10,20,30,40,50])
  const minutes = target.getMinutes();
  const ceiled = Math.ceil(minutes / 10) * 10;
  if (ceiled === 60) {
    target.setHours(target.getHours() + 1, 0, 0, 0);
  } else {
    target.setMinutes(ceiled, 0, 0);
  }

  const y = target.getFullYear();
  const m = String(target.getMonth() + 1).padStart(2, '0');
  const d = String(target.getDate()).padStart(2, '0');
  const h = String(target.getHours()).padStart(2, '0');
  const mi = String(target.getMinutes()).padStart(2, '0');
  return `${y}-${m}-${d}T${h}:${mi}`;
}
